module.exports = __webpack_public_path__ + "img/hyj6.db82f6b7.png";